import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, Outlet } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store';

import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import LoadingSpinner from './components/common/LoadingSpinner';
import BottomNavigation from './components/common/BottomNavigation';
import NotificationContainer from './components/common/NotificationContainer';
import useDeviceDetection from './pages/useDeviceDetection';

// Import styles
// import './styles/feedback.css';
// Lazy load pages
const HomePage = lazy(() => import('./pages/HomePage'));
const AboutPage = lazy(() => import('./pages/AboutPage'));
const ProductsPage = lazy(() => import('./pages/ProductsPage'));
const ProductDetailPage = lazy(() => import('./pages/ProductDetailPage'));
const GalleryPage = lazy(() => import('./pages/GalleryPage'));
const ContactPage = lazy(() => import('./pages/ContactPage'));
const PaymentPage = lazy(() => import('./pages/PaymentPage'));
const GraniteShowroomPhone = lazy(() => import('./pages/GraniteShowroomPhone'));
const GraniteShowroomLaptop = lazy(() => import('./pages/GraniteShowroomLaptop'));



// Layout component for standard pages
const StandardLayout = () => (
  <>
    <Header />
    <main>
      <Outlet />
    </main>
    <Footer />
    <BottomNavigation />
    {/* Global notification container */}
    <NotificationContainer />
  </>
);
const ShowroomRouter = () => {
  const { isMobile } = useDeviceDetection();
  
  return isMobile ? <GraniteShowroomPhone /> : <GraniteShowroomLaptop />;
};

// function App() {
//   return (
//     <Provider store={store}>
//       <Router>
//         <Suspense fallback={<LoadingSpinner />}>
//           <Routes>
//             {/* Showroom route WITHOUT standard layout */}
//             <Route path="/showroom" element={<GraniteShowroom />} />
            
//             {/* All other routes WITH standard layout */}
//             <Route element={<StandardLayout />}>
//               <Route path="/" element={<HomePage />} />
//               <Route path="/about" element={<AboutPage />} />
//               <Route path="/products" element={<ProductsPage />} />
//               <Route path="/products/:id" element={<ProductDetailPage />} />
//               <Route path="/gallery" element={<GalleryPage />} />
//               <Route path="/contact" element={<ContactPage />} />
//               <Route path="/payment" element={<PaymentPage />} />
//             </Route>
//           </Routes>
//         </Suspense>
//       </Router>
//     </Provider>
//   );
// }
function App() {
  return (
    <Provider store={store}>
      <Router>
        <Suspense fallback={<LoadingSpinner />}>
          <Routes>
            {/* Showroom route with device detection */}
            <Route path="/showroom" element={<ShowroomRouter />} />
            
            {/* All other routes WITH standard layout */}
            <Route element={<StandardLayout />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/products" element={<ProductsPage />} />
              <Route path="/products/:id" element={<ProductDetailPage />} />
              <Route path="/gallery" element={<GalleryPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/payment" element={<PaymentPage />} />
            </Route>
          </Routes>
        </Suspense>
      </Router>
    </Provider>
  );
}
export default App;